/* Sabatino Tartufi — minimal theme JS
   Handles AJAX add-to-cart from product cards and updates the header count. */
(function () {
  'use strict';

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();

    var button = form.querySelector('[type="submit"]');
    if (button) button.setAttribute('disabled', 'disabled');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(new FormData(form).get('id')), quantity: 1 }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (button) button.removeAttribute('disabled');
        var note = form.querySelector('[data-added-note]');
        if (note) {
          note.hidden = false;
          setTimeout(function () { note.hidden = true; }, 2500);
        }
      })
      .catch(function () {
        if (button) button.removeAttribute('disabled');
        window.location.href = '/cart';
      });
  });
})();
